import { ApiProperty } from '@nestjs/swagger';
export class ContainerLoadingFileUploadDto {
    @ApiProperty({ type: 'file', format: 'binary' })
    file: string;
    @ApiProperty()
    containerLogBookId: number;
}